/* eslint-disable max-len */
import { NgModule } from '@angular/core';

import { BillingAutoPayDataAccessModule } from '@amfam/billing/auto-pay/data-access';
import { BillingAutoPayDetailFeatureModule } from '@amfam/billing/auto-pay/detail/feature';
import { AutoPaySetupStateModule } from '@amfam/billing/auto-pay/feature';
import { BillingDetailFeatureModule } from '@amfam/billing/detail/feature';
import { OneTimePayStateModule } from '@amfam/billing/one-time-pay/feature';
import { BillingPaymentHistoryFeatureModule } from '@amfam/billing/payment-history/feature';
import { BillingPaymentMethodDataAccessModule } from '@amfam/billing/payment-method/data-access';
import {
  BillingPaymentMethodFeatureModule,
  PaymentMethodFeatureStateModule
} from '@amfam/billing/payment-method/feature';
import { BillingPaymentaccountFeatureModule } from '@amfam/billing/paymentaccount/feature';
import { BillingSchedulepaymentFeatureModule } from '@amfam/billing/schedulepayment/feature';
import {
  BillingSharedFeatureModule,
  BillingSharedStateModule
} from '@amfam/billing/shared/feature';
import { BillingStatementHistoryFeatureModule } from '@amfam/billing/statement-history/feature';
import { OverviewBillingFeatureModule } from '@amfam/overview/billing/feature';
import { ProfileFeatureModule } from '@amfam/profile/feature';
import { SharedAnalyticsModule } from '@amfam/shared/analytics';

import { AutopayOverviewCardComponent } from '../account/overview/components/autopay-overview-card/autopay-overview-card.component';
import { ProfileModule } from '../profile/profile.module';
import { SharedModule } from '../shared/shared.module';
import { BillAccountContactConfirmationComponent } from './bill-account-contact/bill-account-contact-confirmation/bill-account-contact-confirmation.component';
import { BillAccountContactComponent } from './bill-account-contact/bill-account-contact.component';
import { BillAccountDetailComponent } from './bill-account-detail/bill-account-detail.component';
import { BillAccountFaqComponent } from './bill-account-faq/bill-account-faq.component';
import { BillAccountRegisterWrapperComponent } from './bill-account-register-wrapper/bill-account-register-wrapper.component';
import { BillAccountSectionComponent } from './bill-account-section/bill-account-section.component';
import { BillingPaperlessPreferenceComponent } from './billing-paperless-preference/billing-paperless-preference.component';
import { BillingPaymentErrorItemComponent } from './shared/billing-payment-error/billing-payment-error-item/billing-payment-error-item.component';
import { BillingPaymentErrorComponent } from './shared/billing-payment-error/billing-payment-error.component';

@NgModule({
  imports: [
    SharedAnalyticsModule,
    SharedModule,
    ProfileModule,
    ProfileFeatureModule,
    BillingPaymentaccountFeatureModule,
    BillingStatementHistoryFeatureModule,
    BillingPaymentHistoryFeatureModule,
    BillingSchedulepaymentFeatureModule,
    BillingDetailFeatureModule,
    BillingSharedFeatureModule,
    BillingPaymentMethodDataAccessModule,
    BillingAutoPayDataAccessModule,
    AutoPaySetupStateModule,
    BillingAutoPayDetailFeatureModule,
    OneTimePayStateModule,
    BillingPaymentMethodFeatureModule,
    BillingSharedStateModule,
    PaymentMethodFeatureStateModule,
    OverviewBillingFeatureModule
  ],
  declarations: [
    BillAccountSectionComponent,
    BillAccountDetailComponent,
    BillAccountContactComponent,
    BillAccountRegisterWrapperComponent,
    BillingPaperlessPreferenceComponent,
    BillAccountFaqComponent,
    BillingPaymentErrorComponent,
    BillingPaymentErrorItemComponent,
    BillAccountContactConfirmationComponent,
    AutopayOverviewCardComponent
  ],
  exports: [AutopayOverviewCardComponent]
})
export class BillingModule {}
